/**
 * Сделать первую букву строки заглавной
 */
export const capitalize = (term: string | null | undefined) => {
  if (!term) return '';
  return term.charAt(0).toUpperCase() + term.slice(1);
};

/** Проверка пароля */
export const checkPasswordNotSpaceNotCyrillic = (str: string) => {
  const re = new RegExp(`^(?=.*[A-Z])(?=.*\\d)(?=.*[@#$&*%])[A-Za-z\\d@#$&*%!^+-=~\\\`]{16,}$`);
  return re.test(str);
};

export const addZeroToStart = (num: number) => {
  return num.toString().length < 2 ? '0' + num : num;
};
